import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { ClockIcon, UsersIcon, BrainIcon, ArrowRightIcon, GiftIcon, CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function PainSection() {
  return <SectionWrapper data-id="element-441">
      <div className="mb-10" data-id="element-442">
        <h2 className="text-2xl md:text-4xl text-white mb-2 font-mono" data-id="element-443">
          <span className="text-cyber-red mr-2" data-id="element-444">{'//'}</span> EL ERROR DEL
          SISTEMA
        </h2>
        <div className="h-1 w-20 bg-cyber-red shadow-neon-red" data-id="element-445"></div>
      </div>

      <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-446">
        Vivir con ansiedad social en 2026 es un{' '}
        <strong className="text-white" data-id="element-447">infierno silencioso</strong>. Es ver cómo
        los demás hacen amigos, consiguen citas y avanzan en la universidad
        mientras tú te quedas atrapado en tu cabeza, sobre-analizando cada
        palabra que dijiste hace tres horas.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-448">
        <div className="bg-cyber-dark p-5 rounded border border-gray-800" data-id="element-449">
          <UsersIcon className="w-7 h-7 text-cyber-red mb-3" data-id="element-450" />
          <p className="text-gray-400 text-sm" data-id="element-451">
            El terror de que el profesor diga "reúnanse en equipos".
          </p>
        </div>
        <div className="bg-cyber-dark p-5 rounded border border-gray-800" data-id="element-452">
          <ClockIcon className="w-7 h-7 text-cyber-red mb-3" data-id="element-453" />
          <p className="text-gray-400 text-sm" data-id="element-454">
            La taquicardia antes de pedir un simple café.
          </p>
        </div>
        <div className="bg-cyber-dark p-5 rounded border border-gray-800" data-id="element-455">
          <BrainIcon className="w-7 h-7 text-cyber-red mb-3" data-id="element-456" />
          <p className="text-gray-400 text-sm" data-id="element-457">
            La soledad de estar rodeado de gente pero sentirte a mil kilómetros
            de distancia.
          </p>
        </div>
      </div>

      <div className="bg-cyber-red/10 border border-cyber-red/30 p-6 rounded-lg text-center relative overflow-hidden mb-8" data-id="element-458">
        <div className="absolute top-0 left-0 w-full h-1 bg-cyber-red shadow-neon-red" data-id="element-459"></div>
        <h3 className="text-xl text-white font-mono mb-3" data-id="element-460">
          ¿Cuánto te está costando esto realmente?
        </h3>
        <p className="text-gray-300 text-sm mb-0" data-id="element-461">
          ¿Cuántas oportunidades, cuántas relaciones y cuánta paz mental has
          perdido por miedo al juicio de personas que ni siquiera te importan?
          El costo de no hacer nada es quedarte exactamente donde estás hoy:{' '}
          <strong className="text-cyber-red" data-id="element-462">
            solo, frustrado y con miedo al futuro.
          </strong>
        </p>
      </div>

      <div className="text-center flex flex-col items-center gap-2" data-id="element-463">
        <NeonButton href={CHECKOUT_URL} size="lg" data-id="element-464">
          DEJA DE PERDER OPORTUNIDADES → $9.99{' '}
          <ArrowRightIcon className="w-5 h-5" data-id="element-465" />
        </NeonButton>
        <span className="flex items-center gap-1.5 text-[11px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1.5 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-466">
          <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-467" />
          <span className="text-gray-300" data-id="element-468">
            + 2 Bonos <strong className="text-cyber-neon" data-id="element-469">GRATIS</strong>{' '}
            incluidos <span className="text-gray-500" data-id="element-470">(valor $47)</span>
          </span>
        </span>
        <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 max-w-md" data-id="element-471">
          <div className="flex items-start gap-2" data-id="element-472">
            <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-473" />
            <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-474">
              <span className="text-gray-300 font-bold" data-id="element-475">Bonus 1:</span> Scripts
              de Supervivencia en Citas — qué decir para que nunca haya
              silencios incómodos.
              <span className="ml-1 text-gray-500 line-through" data-id="element-476">$25</span>
              <span className="ml-1 text-cyber-neon font-bold" data-id="element-477">GRATIS</span>
            </p>
          </div>
          <div className="flex items-start gap-2" data-id="element-478">
            <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-479" />
            <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-480">
              <span className="text-gray-300 font-bold" data-id="element-481">Bonus 2:</span>{' '}
              Templates de Texto Irresistibles — para que nunca más te dejen en
              "visto" en WhatsApp.
              <span className="ml-1 text-gray-500 line-through" data-id="element-482">$22</span>
              <span className="ml-1 text-cyber-neon font-bold" data-id="element-483">GRATIS</span>
            </p>
          </div>
          <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-484">
            <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-485">
              Te ahorras $47 USD en bonos de regalo
            </p>
          </div>
        </div>
        <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
        behavior: 'smooth'
      })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors" data-id="element-486">
          Leer más
        </button>
      </div>
    </SectionWrapper>;
}